import { formatLocalDateTimeIso } from './formatDates';

export const epochToLocalDateTimeIso = (epoch?: string) => {
  if (!epoch) return undefined;

  const date = new Date(Number(epoch));
  if (isNaN(date.getTime())) return undefined;

  return formatLocalDateTimeIso(date);
};
